export default "__VITE_ASSET__BBiRgupX__"